import React from 'react';
import { useField } from 'formik';
import { TextField } from '@mui/material';

interface Props {
  name: string;
  label: string;
  [key: string]: any;
}

const QiEmailField = (props: Props) => {
  const { label, ...rest } = props;
  const [field, meta] = useField(props);

  const errorText = meta.touched && meta.error ? meta.error : '';

  return (
    <TextField
      {...field}
      {...rest}
      label={label}
      // Usamos type="text" en lugar de "email" para que el navegador no sugiera correos guardados
      type="text" 
      error={!!errorText}
      helperText={errorText}
      variant="outlined"
      inputProps={{
        readOnly: true,
        // 'one-time-code' es uno de los valores que más respetan los navegadores para NO autocompletar
        autoComplete: 'one-time-code', 
        ...rest.inputProps,
      }}
      onFocus={(e: any) => {
        e.target.readOnly = false;
        if (rest.onFocus) rest.onFocus(e);
      }}
      // Evita que el navegador intente "ayudar" con el corrector ortográfico
      spellCheck={false}
    />
  );
};

export default QiEmailField;
